export default "__VITE_ASSET__CC2O28GP__"